import React from 'react'

const LampIcon = ({
    width="26" ,
    height="26"
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.75 22.75H16.25" stroke="#18488A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13 3.25C9.41015 3.25 6.5 6.16015 6.5 9.75C6.5 11.2584 7.01378 12.6467 7.87587 13.7496C8.82849 14.9684 9.75 16.333 9.75 17.8798V18.4169C9.75 19.0152 10.235 19.5002 10.8333 19.5002H15.1667C15.765 19.5002 16.25 19.0152 16.25 18.4169V17.8798C16.25 16.333 17.1715 14.9684 18.1241 13.7496C18.9862 12.6467 19.5 11.2584 19.5 9.75C19.5 6.16015 16.5899 3.25 13 3.25Z" stroke="#FFD200" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    
  )
}

export default LampIcon